import { PayrollAccountingTypeEnum } from '@thinknet-gmbh/platform-common';

export const PAYROLL_ACCOUNTING_TABS = {
  datev: PayrollAccountingTypeEnum.DATEV.toLowerCase(),
};
